import {useEffect, useState} from 'react';

import {GROWTHBOOK_EVENTS} from '../../growthbook/constants';
import {handleGrowthBookUpdateEvent} from '../helpers/growthbook';

const useGrowthbook = () => {
  const [growthBook, setGrowthBook] = useState(window.growthBook);

  const growthBookLoadHandler = state => {
    setGrowthBook(state);
  };

  useEffect(() => {
    handleGrowthBookUpdateEvent(growthBookLoadHandler);

    return () => document.removeEventListener(GROWTHBOOK_EVENTS.LOAD, growthBookLoadHandler);
  }, []);

  return growthBook;
};

export {useGrowthbook};
